import NormalNode from '@ps/views/workbench/board/storyboard/node.vue'
import { Cell, Graph } from '@antv/x6'

export function addDagNode({
  x,
  y,
  metaData,
  graph
}: {
  x: number;
  y: number;
  metaData: Cell.Metadata;
  graph: Graph;
}) {
  const node = graph.addNode({
    attrs: {
      // body: {
      //   stroke: 'red'
      // }
    },
    ...metaData,
    // x、y 等于场景坐标加上节点在场景的坐标之和
    x,
    y,
    component: {
      template: `<normal-node :node-id="data.nodeId" :target-scene-id="data.switchSceneId"></normal-node>`,
      data() {
        return metaData
      },
      methods: {},
      components: {
        NormalNode
      }
    },
    shape: 'vue-shape'
  })
  return node
}
